import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import Appbar from "./Sections/Appbar/Appbar";
import Header from "./Sections/Header/Header";
import About from "./Sections/About/About";
import Skill from "./Sections/Skill/Skill";
import Resume from "./Sections/Resume/Resume";
import Referance from "./Sections/Referance/Referance";
import Contact from "./Sections/Contact/Contact";

import AnchorLink from "react-anchor-link-smooth-scroll";
import { Link, animateScroll as scroll } from "react-scroll";
import ReactGA from "react-ga";
import Projects from "./Sections/Projects/Projects";

import { createGlobalStyle, ThemeProvider } from "styled-components";

const styledtheme = {
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 768,
    lg: 992,
    xl: 1200,
  },
};

function App() {
  useEffect(() => {
    ReactGA.initialize("G-DGN9B34XPK");

    ReactGA.pageview(window.location.pathname);
    const ele = document.getElementById("ipl-progress-indicator");
    if (ele) {
      // fade out
      const theTimeout = setTimeout(() => {
        // remove from DOM
        ele.classList.add("available");
        ele.outerHTML = "";
      }, 2000);
      return () => {
        clearTimeout(theTimeout);
      };
    }
  }, []);

  return (
    <ThemeProvider theme={styledtheme}>
      <div className="App">
        <Header />
        <About />
        <Skill />
        <Resume />
        <Projects />
        {/* <Referance /> */}
        <Contact />
        <sumna-widget></sumna-widget>
      </div>
    </ThemeProvider>
  );
}

export default App;
